// Espejo (solo lectura) del backend app/modulos_catalogo.py — mapea cada
// ruta del frontend a los módulos que la habilitan (semántica OR: basta con
// uno). Se usa SOLO para no mostrar en el menú/ruta un módulo que la
// empresa no tiene contratado; el backend es la barrera real (login_required
// revisa esto mismo en cada request — ver decorators.py). Si algún día se
// desincroniza, lo peor que pasa es que la UI muestre o esconda de más un
// botón que de todos modos el backend acepta o rechaza correctamente.
export const RUTA_MODULOS: Record<string, string[]> = {
  "/compras": ["contabilidad"],
  "/produccion": ["contabilidad"],
  "/costeo": ["contabilidad"],
  "/inventarios-op": ["contabilidad"],
  "/comercial": ["facturacion"],
  "/gerencial": ["contabilidad"],
  "/contabilidad": ["contabilidad"],
  "/nomina": ["nomina"],
  "/cumplimiento": ["contabilidad"],
  "/pos": ["pos", "restaurante"],
  "/pos/mostrador": ["pos", "restaurante"],
  "/notas": ["contabilidad"],
  "/tesoreria": ["contabilidad"],
  "/activos": ["contabilidad"],
  "/informes": ["contabilidad"],
  "/restaurante": ["restaurante", "pos"],
  "/dian": ["facturacion"],
  "/sigepro-ep": ["sigepro_ep"],
  // "/reportes" y las rutas de Core (empresa, usuarios, roles, parámetros,
  // catálogos, productos, auditoría) NO están aquí a propósito: Reportes.tsx
  // cruza datos de varios módulos a la vez (cada descarga ya se filtra por
  // permiso RBAC y el backend igual la bloquea si el módulo específico no
  // está licenciado) y Core nunca se licencia por separado.
};

export function moduloDisponible(ruta: string, modulosLicenciados: string[] | undefined): boolean {
  const requeridos = RUTA_MODULOS[ruta];
  if (!requeridos) return true; // ruta no sujeta a licenciamiento por módulo
  if (!modulosLicenciados) return false;
  return requeridos.some((m) => modulosLicenciados.includes(m));
}
